module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-157.b7c90964.svg";